import React from "react";
import {Helmet} from "react-helmet-async";
import {Link} from "react-router-dom";
import LegalLayout from "../../components/eas/LegalLayout";

export default function LegalTermsPage(): JSX.Element {
    return (
        <>
            <Helmet>
                <title>Terms and Conditions — Effective Action System</title>
                <meta name="description"
                      content="Terms and Conditions of the EFFECTIVEACTIONSYSTEM.COM Service — index of applicable regulations."/>
                <link rel="canonical" href="https://effectiveactionsystem.com/legal/terms"/>
            </Helmet>
            <LegalLayout title="Terms and Conditions of the EFFECTIVEACTIONSYSTEM.COM Service" lastUpdated="6 May 2026">
                <p>The following documents together govern the use of the EFFECTIVEACTIONSYSTEM.COM Service operated by
                    PRODUKACJA Sp. z o.o.:</p>
                <ol>
                    <li>
                        The General Terms and Conditions are available at{' '}
                        <Link to="/legal/terms/general">this link</Link>.
                    </li>
                    <li>
                        The Online Course Terms and Conditions are available at{' '}
                        <Link to="/legal/course-terms">this link</Link>.
                    </li>
                    <li>
                        The Effective Action System Special Offer Terms are available at{' '}
                        <Link to="/legal/eas-offer-terms">this link</Link>.
                    </li>
                </ol>
                <p style={{color: "rgba(255,255,255,0.7)"}}>
                    By purchasing access to any Course, the User accepts both the General Terms and Conditions and the
                    Online Course Terms and Conditions.
                </p>
                <p style={{color: "rgba(255,255,255,0.7)"}}>
                    By purchasing the <strong>Effective Action System</strong>, the User additionally accepts the
                    Effective Action System Special Offer Terms, which supplement the Online Course Terms and Conditions.
                    In the event of any discrepancy, the Special Offer Terms take precedence with respect to the
                    Effective Action System.
                </p>
                <p style={{color: "rgba(255,255,255,0.7)"}}>
                    By purchasing any service that is not an Online Course, the User accepts the General Terms and
                    Conditions.
                </p>
            </LegalLayout>
        </>
    );
}
